import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'crewnik', 'crewname', 'crewkey', 'ClaimID', 'NmClaim','outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/benefitclaim${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/benefitclaim', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/benefitclaim/${obj.ClaimHistID}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/benefitclaim/detail/${obj.ClaimHistID}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'crewnik', 'crewname', 'crewkey', 'ClaimID', 'NmClaim','outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/benefitclaim/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'benefitclaim_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.ClaimHistID) {
                    // const url = `/benefitclaim/print?ClaimHistID=${obj.ClaimHistID}`;
                    // const { data } = await axios.get(url);
                    const { data } = await axios.get(`/benefitclaim/print/${obj.ClaimHistID}`);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("benefitclaim/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/benefitclaim/send2wfCancel/${obj.ClaimHistID}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

};